import { useMemo, useEffect } from "react";
import { createCustomEvent } from "./utils.js";
async function handlePageView(pageDetails) {
  const details = await pageDetails();
  if (details !== void 0) {
    dispatchPageView(() => Promise.resolve(details));
  }
}
function useTrackPageView(pageDetails) {
  useEffect(() => {
    handlePageView(pageDetails);
  }, [pageDetails]);
}
function useDispatchTrackPageView() {
  const pageViewDispatcher = useMemo(() => {
    return async (pageDetails) => {
      await handlePageView(pageDetails);
    };
  }, []);
  return pageViewDispatcher;
}
async function dispatchPageView(pageDetails) {
  try {
    const details = await pageDetails();
    if (details !== void 0) {
      const event = createCustomEvent(details);
      globalThis.dispatchEvent(event);
    }
  } catch (error) {
    console.error("Error dispatching page view event:", error);
  }
}
export {
  useDispatchTrackPageView,
  useTrackPageView
};
//# sourceMappingURL=use-track-page-view.js.map
